/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Detail_Col_MaterialsInputs */

const vi_pll_detail_col_materials = /** @type {(inputs: Pll_Detail_Col_MaterialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {Pll_Detail_Col_MaterialsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_detail_col_materials = /** @type {((inputs?: Pll_Detail_Col_MaterialsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Detail_Col_MaterialsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_detail_col_materials(inputs)
});